// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2R0wJ","list":"BalanceDue_list__1hp_k","listRow":"BalanceDue_listRow__Zacsq","total":"BalanceDue_total__1-DHx"};